module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'right'
      }),
      expression: "{arrow: true,placement : 'right'}"
    }],
    staticClass: "team-calendar-activator text-dark no-print",
    class: {
      'team-calendar-activator--is-active': _vm.showTeamCalendar
    },
    attrs: {
      "content": '<p class=' + 'tooltip-shortcut' + '>' + _vm.$t('vue2.common.press') + '<span>S</span></p>'
    },
    on: {
      "click": _vm.toggleShowTeamCalendar
    }
  }, [_c('button', {
    staticClass: " box-shadow submit-button button--rounded"
  }, [(!_vm.showTeamCalendar) ? _c('span', {
    staticClass: "icon-users"
  }) : _c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.i18n[_vm.locale]['button_text'])
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.showTeamCalendar) ? _c('div', {
    staticClass: "background-overlay"
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideUp"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTeamCalendar),
      expression: "showTeamCalendar"
    }],
    staticClass: "overlay-calendars text-dark"
  }, [_c('div', {
    staticClass: "team-calendar",
    class: {
      'team-calendar--week-view': _vm.calView === 'resourceTimeGridFiveDay'
    }
  }, [_c('div', {
    staticClass: "team-calendar__header flex space-between no-print"
  }, [_c('h1', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['team_calendar']))]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle team-calendar__close-cross pointer font-large no-print",
    on: {
      "click": _vm.closeTeamCalendar
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "team-calendar__body"
  }, [_c('calHeader', {
    attrs: {
      "date": _vm.date,
      "calview": _vm.calView,
      "itemsSelected": _vm.selectedRess,
      "selectedScrollOption": _vm.selectedScrollOption
    },
    on: {
      "dateChange": _vm.setDate,
      "setView": _vm.setCalView,
      "updateEvents": _vm.updateEvents,
      "usersUpdated": _vm.setSelectedRess,
      "changedSortOption": _vm.setSortOption,
      "setSelectedScrollOption": _vm.setSelectedScrollOption
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "team-calendar__calendars",
    class: {
      'team-calendar__calendars--loading-events': _vm.isLoadingEvents && _vm.isCalendarView
    },
    attrs: {
      "id": "printTeamCalendar"
    }
  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isLoadingEvents && _vm.isCalendarView) ? _c('div', {
    staticClass: "team-calendar__loader-container"
  }, [_c('spinner', {
    attrs: {
      "bg-color": "#fff"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "italic"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['loading_events']))])], 1) : _vm._e(), _vm._v(" "), (_vm.calView === 'doubleBookings') ? _c('Collisions', {
    attrs: {
      "date": _vm.date,
      "show": _vm.showTeamCalendar
    },
    on: {
      "prevDay": _vm.setPrevDay,
      "nextDay": _vm.setNextDay
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSchedulerView && !_vm.isLoading) ? _c('dScheduler', {
    attrs: {
      "calendars": _vm.selectedRess,
      "events": _vm.events,
      "title": _vm.schedulerDate,
      "isLoading": _vm.isLoadingEvents
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowSchedulerShortcut) ? _c('dScheduler', {
    attrs: {
      "title": _vm.schedulerDate,
      "calendars": _vm.theSchedulerCalendars,
      "isLoading": _vm.isLoadingEvents,
      "events": _vm.theSchedulerEvents,
      "sortBy": _vm.theSortOptionForAllSchedules
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "zoomIn"
    }
  }, [(_vm.activeEvent) ? _c('DCalendarShowEvent', {
    attrs: {
      "event": _vm.activeEvent,
      "calendar": _vm.activeCalendar,
      "initCalendarId": _vm.activeEventCalendarId
    },
    on: {
      "updated": _vm.updateEvents,
      "close": function($event) {
        return _vm.setActiveEvent(null)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.selectedRess.length > 0 && _vm.isCalendarView && !_vm.isLoading) ? _c('div', {
    ref: "calContainerRef",
    staticClass: "calendar_container",
    class: {
      'calendar_container--side-scroll': _vm.selectedScrollOption === 'horizontal'
    }
  }, [_c('div', {
    staticClass: "d-cals"
  }, _vm._l((_vm.selectedRess), function(calendar, idx) {
    return _c('div', {
      key: calendar.id,
      staticClass: "d-cals__calendar"
    }, [_c('DCalendar', {
      attrs: {
        "initNumberOfDays": _vm.userCustomNumberOfDays,
        "isMultiCalendar": true,
        "isShowStudents": true,
        "date": _vm.date,
        "isEventsClickable": _vm.isUserCanEditCalendar,
        "events": _vm.getCalendarEvents(calendar.id),
        "startTime": _vm.startTime,
        "endTime": _vm.endTime,
        "isShowWeek": _vm.isShowWeek,
        "isShowWeekends": _vm.isShowWeekends,
        "calendarId": calendar.id,
        "calendarName": calendar.name,
        "showSidebar": idx % 5 === 0,
        "isShowAsList": _vm.isListView
      },
      on: {
        "onEventClick": function($event) {
          return _vm.setActiveEvent($event, calendar)
        }
      }
    })], 1)
  }), 0)]) : _vm._e()], 1)], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ebad7330!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeamCalendar/TeamCalendar.vue
// module id = 1770
// module chunks = 1